<div class="backoffice-edit-space-container">
  <div class="title">
    {{ "backoffice.space.modal-edit.title" | translate }}
  </div>
  <div class="form" *ngIf="ready">
    <label class="center-block">{{ "backoffice.space.modal-edit.available" | translate }}:
      <input type="number" [(ngModel)]="spaceInfo.quantity" />
    </label>
    <label class="center-block">{{ "backoffice.space.modal-edit.places" | translate }}:
      <input type="number" [(ngModel)]="spaceInfo.capacity" />
    </label>
    <label class="center-block">{{ "backoffice.space.modal-edit.type" | translate }}:
      <select [(ngModel)]="selectedType">
        <option *ngFor="let option of spaceTypes" [ngValue]="option">
          {{ option.title }}
        </option>
      </select>
    </label>
    <form [formGroup]="editSpaceForm">
      <div *ngFor="let control of formControl; let i = index">
        <div [formGroupName]="i" class="section-form">
          <span>{{ spaceInfo.prices[i].title }}</span>
          <label class="center-block">{{ "Precio privado â¬" }}:
            <input formControlName="private_price" class="form-control" type="number" />
          </label>
          <label class="center-block">{{ "Precio publico C" }}:
            <input formControlName="public_price" class="form-control" type="number" />
          </label>
        </div>
      </div>
    </form>
  </div>
  <div class="footer">
    <cowing-button [disabled]="editSpaceForm.invalid" [label]="'Guardar'" [type]="EButtonType.Rounded"
      [iconShow]="false" (event)="editSpace()">
    </cowing-button>
  </div>
</div>